import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { CoreMappingsBuyer } from '../core-mappings-state.model';

export const CoreMappingsActions = createActionGroup({
  source: 'Core Mappings',
  events: {
    'Load Buyers': emptyProps(),
    'Load Buyers Success': props<{ buyers: readonly CoreMappingsBuyer[] }>(),
    'Load Buyers Failure': props<{ error: string }>(),

    'Upload Mappings': props<{ file: File; buyerId: string }>(),
    'Upload Mappings Success': props<{ message: string }>(),
    'Upload Mappings Failure': props<{ error: string }>(),
    'Upload Mappings Reset': emptyProps(),

    'Download Mappings': props<{ buyerId: string; fileName: string }>(),
    'Download Mappings Success': emptyProps(),
    'Download Mappings Failure': props<{ error: string }>(),
    'Download Mappings Reset': emptyProps(),
  },
});
